import firedux from '../firedux'
import {dispatch} from '../store'

import setAdvertisements from '../actions/set_advertisements'

import {
  ADVERTISEMENTS_ENDPOINT
} from '../../config/constants'

const onAdvertisements = (snapshot) => {
  if (!snapshot.exists()) return

  const advs = snapshot.val()

  dispatch(setAdvertisements(advs))
}

export const watchAdvertisements = () => {
  firedux.ref.child(ADVERTISEMENTS_ENDPOINT)
    .on('value', onAdvertisements)
}

export const unwatchAdvertisements = () => {
  firedux.ref.child(ADVERTISEMENTS_ENDPOINT)
    .off('value', onAdvertisements)
}


/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/advertisements.js
 **/